<template style="">
  <div class="Game_a_type">

    <el-row :gutter="20">
      <el-col :span="20">
        <div class="grid-content bg-purple Game_a_type_left">
          <div class="Game_table" style="position: relative;">
            <div style="position: absolute;top: 0px;left: 0px;right: 0px;bottom: 0px;margin: auto;width: 80%;height: 180px;background-color: #D6CCBF;text-align: center;line-height: 180px;color: #574E3E;font-size: 24px;">
              xaxax
            </div>
          </div>
        </div>
      </el-col>

      <el-col :span="4">
        <div style="height: 100%;" class="grid-content bg-purple">
          <ul class="Game_a_type_right">

            <li>
              <h3 style="text-align: center;padding-top: 30px;color: rgba(201,162,88,1);">数字方格</h3>
              <p style="text-align: left;margin-left: 20px;margin-top: 15px; color: rgba(201,162,88,1);">难度：自定义</p>
              <p style="text-align: left;margin-left: 20px;margin-top: 15px; color: rgba(201,162,88,1);">状态：训练进行中</p>
              <p style="text-align: left;margin-left: 20px;margin-top: 15px; color: rgba(201,162,88,1);">错误：{{ wrong }}</p>
            </li>

            <li>
              <h3 style="text-align: center;padding-top: 55px;color: rgba(201,162,88,1);">
                <p>剩余时间</p>
                <p style="font-size: 24px;color: red;margin-top: 20px;">{{ myTime }}</p>
              </h3>
            </li>

            <li>
              <p style="text-align: center;padding-top:50px;"><el-button type="primary" @click="Startover()">重新开始</el-button></p>
              <p style="text-align: center;margin-top: 20px;"><el-button type="primary">难度选择</el-button></p>
              <p style="text-align: center;margin-top: 20px;"><el-button type="primary">退出    </el-button></p>
            </li>

          </ul>
        </div>
      </el-col>
    </el-row>

  </div>
</template>
<script>
export default {
  data() {
    return {
      CharQty:0,//字符长度
      QstQty:0,//题目数量
      StimulusExposureTime:0,//靶刺激呈现时间
      ProbeExposureTime:0,//探查刺激呈现时间
      right: 0,//答题正确计数器
      wrong: 0,//答题错误计数器
      pass: 0,//未作答计数器
      myTime: 0,//显示的倒计时
    }
  },
  
  mounted() {
  },
  methods: {
    Startover() {//重新开始
    },
    //随机产生字符串
   randomRange(min, max) {
      var returnStr = "",
        range = (max ? Math.round(Math.random() * (max - min)) + min : min),
        arr = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9', 'a', 'b', 'c', 'd', 'e', 'f', 'g', 'h', 'i', 'j', 'k', 'l', 'm', 'n', 'o', 'p', 'q', 'r', 's', 't', 'u', 'v', 'w', 'x', 'y', 'z'];
      for (var i = 0; i < range; i++) {
        var index = Math.round(Math.random() * (arr.length - 1));
        returnStr += arr[index];
      }
      return returnStr;
    }

  }
}

</script>

<style>
  .Game_a_type{width: 100%;height: 100%;}
  .Game_a_type td{width: 40px;height: 40px;border: 1px saddlebrown solid;text-align: center;}
  .Game_table{height: 100%;width: 100%;position: relative;}
  .Game_a_type table{position: absolute;top: 0px;left: 0px;right: 0px;bottom: 0px;margin: auto;}
  .Game_a_type .el-row{height: 100%;}
  .Game_a_type .el-col-20{height: 100%;}
  .Game_a_type .el-col-4{height: 100%;}
  .Game_a_type_left{height: 100%;background-image: url('../../assets/div3_left1.png');background-size: 100% 100%;background-color: #C4E8DC;}
  .Game_a_type_right li{margin-top: 15px;}
  .Game_a_type_right{height: 100%;}
  .Game_a_type_right li:nth-child(1){height: 30%;background-image: url('../../assets/div3_right1.png');background-size: 100% 100%;margin-top: 0px;}
  .Game_a_type_right li:nth-child(2){height: 20%;background-image: url('../../assets/div3_right1.png');background-size: 100% 100%;}
  .Game_a_type_right li:nth-child(3){height: calc(50% - 25px);background-image: url('../../assets/div3_right1.png');background-size: 100% 100%;}
  .Game_table td{text-align: center;line-height: 40px;}
</style>
